import { gql } from "@apollo/client";

const GET_INVOICE_DUPLICATES = gql`
  query getInvoiceDuplicates($clientIdentifier: String!, $invoiceId: String!) {
    invoice(clientIdentifier: $clientIdentifier, invoiceId: $invoiceId) {
      id
      invoiceNumber
      duplicateInvoices {
        id
        invoiceNumber
        state {
          processStatus
        }
        createdAt
        dueDate
        invoiceDate
        invoiceNumber
        currencyCode
        invoiceRecipient {
          name
          client {
            id
          }
        }
        totalAmountWithVat
        tags {
          tag
        }

        serviceType
      }
    }
  }
`;

export default GET_INVOICE_DUPLICATES;
